import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import Sidebar from "./components/ui/Sidebar";
import { useSidebar, SidebarProvider } from "./hooks/useSidebar";
import ModuleSelectionDashboard from './pages/module-selection-dashboard/index';
import WorkPermitTracking from './pages/work-permit-tracking/index';
import SafetyAnalyticsDashboard from './pages/safety-analytics-dashboard/index';
import IncidentInvestigationTracker from './pages/incident-investigation-tracker/index';
import RiskIdentificationDashboard from './pages/risk-identification-dashboard/index';
import ProcessSafetyInformationRepository from './pages/process-safety-information-repository/index';
import ChemicalInformationManager from './pages/chemical-information-manager/index';
import MaterialDatabaseIntegrationHub from './pages/material-database-integration-hub/index';
import SafetyAuditDashboard from './pages/safety-audit-dashboard/index';
import AuditSurveyBuilder from './pages/audit-survey-builder/index';
import AuditResponseTracker from './pages/audit-response-tracker/index';
import TaskManagementApprovalCenter from './pages/task-management-approval-center/index';
import AIVisionIntegrationControlCenter from './pages/ai-vision-integration-control-center/index';
import UnsafeActsConditionsAnalyticsDashboard from './pages/unsafe-acts-conditions-analytics-dashboard/index';
import UnsafeActsConditionsEntryForm from './pages/unsafe-acts-conditions-entry-form/index';
import TrainingComplianceDashboard from './pages/training-compliance-dashboard/index';
import TrainingMaterialsRepository from './pages/training-materials-repository/index';
import TrainingAssessmentCenter from './pages/training-assessment-center/index';
import StatutoryComplianceAnalyticsDashboard from './pages/statutory-compliance-analytics-dashboard/index';
import ComplianceTaskManager from './pages/compliance-task-manager/index';
import ComplianceDocumentRepository from './pages/compliance-document-repository/index';
import ReportsManagementDashboard from './pages/reports-management-dashboard/index';
import CustomReportBuilder from './pages/custom-report-builder/index';
import NotFound from './pages/NotFound';
import WorkPermitDetails from './pages/work-permit-details/index';
import WorkPermitCreation from './pages/work-permit-creation/index';
import IncidentReportingDashboard from './pages/incident-reporting-dashboard/index';
import IncidentCreationForm from './pages/incident-creation-form/index';
import RiskAnalyticsMatrixViewer from './pages/risk-analytics-matrix-viewer/index';
import ChemicalCompatibilityMatrixManager from './pages/chemical-compatibility-matrix-manager/index';
import HAZIDWorksheetManager from './pages/hazid-worksheet-manager/index';
import AIReportAssistant from './pages/ai-report-assistant/index';
import StatutoryComplianceTimelineValidationCenter from './pages/statutory-compliance-timeline-validation-center/index';
import SafetyControlTower from './pages/safety-control-tower/index';
import IncidentInvestigationWorkspace from './pages/incident-investigation-workspace/index';
import Login from './pages/Login';

const AppLayout = ({ children }) => {
  const { isCollapsed } = useSidebar();
  
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main className={`main-content ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
        {children}
      </main>
    </div>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={
            <SidebarProvider>
            <AppLayout>
              <RouterRoutes>
                <Route path="/module-selection-dashboard" element={<ModuleSelectionDashboard />} />
                <Route path="/work-permit-tracking" element={<WorkPermitTracking />} />
                <Route path="/work-permit-details" element={<WorkPermitDetails />} />
                <Route path="/work-permit-creation" element={<WorkPermitCreation />} />
                <Route path="/module-selection-dashboard" element={<ModuleSelectionDashboard />} />
                <Route path="/safety-analytics-dashboard" element={<SafetyAnalyticsDashboard />} />
                <Route path="/incident-reporting-dashboard" element={<IncidentReportingDashboard />} />
                <Route path="/incident-creation-form" element={<IncidentCreationForm />} />
                <Route path="/incident-investigation-tracker" element={<IncidentInvestigationTracker />} />
                <Route path="/incident-investigation-workspace/:id" element={<IncidentInvestigationWorkspace />} />
                <Route path="/risk-identification" element={<RiskIdentificationDashboard />} />
                <Route path="/risk-analytics-matrix-viewer" element={<RiskAnalyticsMatrixViewer />} />
                <Route path="/process-safety-information-repository" element={<ProcessSafetyInformationRepository />} />
                <Route path="/chemical-information-manager" element={<ChemicalInformationManager />} />
                <Route path="/chemical-compatibility-matrix-manager" element={<ChemicalCompatibilityMatrixManager />} />
                <Route path="/material-database-integration-hub" element={<MaterialDatabaseIntegrationHub />} />
                <Route path="/hazid-worksheet-manager" element={<HAZIDWorksheetManager />} />
                <Route path="/safety-audit-dashboard" element={<SafetyAuditDashboard />} />
                <Route path="/audit-survey-builder" element={<AuditSurveyBuilder />} />
                <Route path="/audit-response-tracker" element={<AuditResponseTracker />} />
                <Route path="/task-management-approval-center" element={<TaskManagementApprovalCenter />} />
                <Route path="/ai-vision-integration-control-center" element={<AIVisionIntegrationControlCenter />} />
                <Route path="/unsafe-acts-conditions-analytics-dashboard" element={<UnsafeActsConditionsAnalyticsDashboard />} />
                <Route path="/unsafe-acts-conditions-entry-form" element={<UnsafeActsConditionsEntryForm />} />
                <Route path="/training-compliance-dashboard" element={<TrainingComplianceDashboard />} />
                <Route path="/training-materials-repository" element={<TrainingMaterialsRepository />} />
                <Route path="/training-assessment-center" element={<TrainingAssessmentCenter />} />
                <Route path="/statutory-compliance-analytics-dashboard" element={<StatutoryComplianceAnalyticsDashboard />} />
                <Route path="/compliance-task-manager" element={<ComplianceTaskManager />} />
                <Route path="/compliance-document-repository" element={<ComplianceDocumentRepository />} />
                <Route path="/compliance-document-export" element={<ComplianceDocumentRepository />} />
                <Route path="/statutory-compliance-timeline-validation-center" element={<StatutoryComplianceTimelineValidationCenter />} />
                <Route path="/safety-control-tower" element={<SafetyControlTower />} />
                <Route path="/statutory-timeline-validation" element={<StatutoryComplianceTimelineValidationCenter />} />
                <Route path="/reports-management-dashboard" element={<ReportsManagementDashboard />} />
                <Route path="/custom-report-builder" element={<CustomReportBuilder />} />
                <Route path="/ai-report-assistant" element={<AIReportAssistant />} />
                <Route path="/safety-control-tower" element={<SafetyControlTower />} />
                <Route path="*" element={<NotFound />} />
              </RouterRoutes>
            </AppLayout>
            </SidebarProvider>
          } />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;